export type TariffVariant = 'Simple' | 'SimpleV2' | 'Basic' | 'Advanced'

export type TariffPeriod = 'Month' | 'HalfYear' | 'Year'

export const TariffTypes: Record<TariffVariant, string> = {
    Simple: 'Простой',
    SimpleV2: 'Простой',
    Basic: 'Базовый',
    Advanced: 'Расширенный',
}

export const parseTariffVariant = (type: string): TariffVariant | null =>
    type === 'Simple' || type === 'SimpleV2' || type === 'Basic' || type === 'Advanced'
        ? type
        : null

const periodLabels: Record<TariffPeriod, string> = {
    Month: '1 мес',
    HalfYear: '6 мес',
    Year: '12 мес',
}

export const formatTariffWithPeriod = (tariff: TariffVariant, period: TariffPeriod): string =>
    `${TariffTypes[tariff]} x ${periodLabels[period]}`
